import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../shared/globals';
import { OcppSettings } from '../models/ocpp-settings.model';
import { Injectable } from "@angular/core";
import { Api } from '../shared/api';
import { ActivateOcppAuthenticationDto } from '../models/activate-ocpp-authentication-dto';

/**
 * Service responsible for getting OCPP settings.
 *
 * @export
 * @class OcppSettingsService
 */
@Injectable()
export class OcppSettingsService {
  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private globals: Globals,
    private api: Api
  ) { }

  /**
   * Gets OCPP settings for the authenticated user
   *
   * @returns {Promise<OcppSettings>}
   * @memberof OcppSettingsService
   */
  public getOcppSettings(): Promise<OcppSettings[]> {
    let token: string;
    return this.authService
      .getToken()
      .then((result) => {
        token = result;
        return this.authService.getUser();
      })
      .then((user) => {
        return this.performGetOcppSettingsRequest(token, user.IdAsString);
      });
  }

  async activateOcppBasicAuthForAccount(
    userId: string,
    secret: string): Promise<void> {

    const activateOcppAuthenticationDto: ActivateOcppAuthenticationDto = {
      secret,
    };

    const url = this.globals.apiUrl(`users/${userId}/ocpp/settings/auth/activate`);
    return await this.api.httpPost(url, activateOcppAuthenticationDto);
  }

  async deactivateOcppBasicAuthForAccount(
    userId: string): Promise<void> {
    const url = this.globals.apiUrl(`users/${userId}/ocpp/settings/auth/deactivate`);
    return await this.api.httpPost(url, {});
  }


  /**
   * Fetches OCPP settings from the API.
   * Requests GET /api/users/:id/ocpp/settings
   *
   * @private
   * @param {string} token - authentication token
   * @param {string} userId
   * @returns {Promise<OcppSettings>}
   * @memberof OcppSettingsService
   */
  private performGetOcppSettingsRequest(
    token: string,
    userId: string
  ): Promise<OcppSettings[]> {
    const url = this.globals.apiUrl('users/' + userId + '/ocpp/settings');
    return new Promise((resolve, reject) => {
      this.http
        .get(url, { headers: this.authService.headers(token) })
        .toPromise()
        .then((response) => {
          const values = Object.keys(response).map((item) =>
            new OcppSettings().deserialize(response[item])
          );
          resolve(values);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
